/**
 * @generated SignedSource<<36715f0817663931eca36b23441d499d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type checkoutTransactionReducer_deliveryOptions$data = {
  readonly isLocalPickup: boolean | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "checkoutTransactionReducer_deliveryOptions";
};
export type checkoutTransactionReducer_deliveryOptions$key = {
  readonly " $data"?: checkoutTransactionReducer_deliveryOptions$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutTransactionReducer_deliveryOptions">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutTransactionReducer_deliveryOptions"
};

(node as any).hash = "3eec008559ffd613c6c4948da69a1e86";

export default node;
